// Created by 任泽阳 on 18/12/25.
// 公共部分路由 (三站公用的路由)
import pcRouter from '../common/common-router';
// import assetsRouter from '../common/assetsRouter';

export default [
  ...pcRouter,
  // 资金管理
  // {
  //   path: '/assets',
  //   name: 'assets',
  //   component: () => import('@/views/assets/index.vue'),
  //   children: [
  //     ...assetsRouter,
  //   ],
  // },
  // // 行情页面
  // {
  //   path: '/market',
  //   name: 'market',
  //   meta: {
  //     footNotMrgin: true,
  //   },
  //   component: () => import('@/views/market/index.vue'),
  // },
];
